import { useEffect, useRef, useState } from "react";
import { useApi } from "../../hooks/use-api";
import { useSingleton } from "../../hooks/use-singleton";
import {
  API_READING_PASSAGE,
  apiReadingPassageGetApi,
} from "../../utils/api-routes";
const topics = ["Culture", "Technology", "Space", "History", "Education"];

export const TOPICS_BY_DIFFICULTY = {
  Beginner: [
    "Animal Adventures",
    "Fairy Tales & Fables",
    "Solar System & Planets",
    "The Water Cycle",
    "Friendship & Kindness",
    "Life in Rainforests",
  ],
  Intermediate: [
    "Great World Explorers",
    "Invention of Internet",
    "Ocean Wonders & Sharks",
    "Ancient Civilizations",
    "Renewable Green Energy",
    "Famous Sports Legends",
  ],
  Advanced: [
    "AI & Future Robotics",
    "Deep Space & Cosmos",
    "Ecosystems & Wildlife",
    "Philosophy & Ethics",
    "Industrial Revolution",
    "Human Psychology",
  ],
};

export const TOPICS = TOPICS_BY_DIFFICULTY.Beginner;

export const LEVELS = ["Beginner", "Intermediate", "Advanced"];

const useHandler = () => {
  const { get, post } = useApi();
  const { mail } = useSingleton();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({
    passageId: "",
    correctCount: "",
    comprehensionScore: "",
    accuracyScore: "",
    title: "",
    passage: "",
    questions: [],
    feedback: "",
  });
  const [answers, setAnswers] = useState({});
  const [submitted, setSubmitted] = useState(false);
  const [score, setScore] = useState(0);
  const [classLevel, setClassLevel] = useState("");
  const [topic, setTopic] = useState("");
  const [difficulty, setDifficulty] = useState("");
  const [showPractice, setShowPractice] = useState(false);
  const audioRef = useRef(null);

  const selectAnswer = (q, value) => {
    setAnswers((prev) => ({
      ...prev,
      [q]: value,
    }));
  };

  const submitAnswers = () => {
    let total = 0;

    data.questions.forEach((item, index) => {
      if (answers[index] === item.answer) {
        total++;
      }
    });

    setScore(total);

    setSubmitted(true);
  };

  const getReadingPassage = async (classLevels, topics, difficulties) => {
    // if (!classLevels.length && !topics.length && !difficulties.length) {
    if (!topics.length && !difficulties.length) {
      return;
    }
    setLoading(true);
    try {
      const res = await get(
        apiReadingPassageGetApi("10", difficulties, topics),
      );

      if (res) {
        console.log(res?.data);
        setData({
          passageId: res?.data?.passage_id,
          title: res?.data.title,
          passage: res?.data.passage,
          questions: res?.data.questions,
          audio_url: res?.data.audio_url,
        });

        setAnswers({});
        setSubmitted(false);
        setScore(0);
        setLoading(false);
        setShowPractice(true);
      }
    } catch (e) {
      console.log("ERROR COMES FROM READING PASSAGE API", e);
      setLoading(false);
    }
  };

  const submitReadingPassage = async () => {
    try {
      setLoading(true);
      const formattedAnswers = {};

      // data.questions.forEach((question, index) => {
      //   const selectedKey = answers[index];

      //   if (selectedKey) {
      //     formattedAnswers[index] = question.options[selectedKey];
      //   }
      // });

      Object.entries(answers).forEach(([index, selectedKey]) => {
        formattedAnswers[index] = selectedKey;
      });

      const payload = {
        passage_id: data.passageId,
        answers: formattedAnswers,
        user_mail: mail,
      };

      const res = await post(API_READING_PASSAGE, payload);

      if (res?.data) {
        setScore(res?.data?.correct_count);

        setData((prev) => ({
          ...prev,
          results: res?.data?.results,
          correctCount: res?.data?.correct_count,
          comprehensionScore: res?.data?.comprehension_score,
          accuracyScore: res?.data?.accuracy_score,
          feedback: res?.data?.feedback,
        }));

        setSubmitted(true);
        setLoading(false);

        console.log(res.data);
      }
    } catch (e) {
      console.log("ERROR COMES FROM SUBMIT READING PASSAGE API", e);
      setLoading(false);
    }
  };

  useEffect(() => {
    if (data?.audio_url && audioRef.current) {
      audioRef.current.play().catch((err) => {
        console.log("Autoplay blocked:", err);
      });
    }
  }, [data?.audio_url]);

  return {
    TOPICS,
    TOPICS_BY_DIFFICULTY,
    LEVELS,
    data,
    answers,
    loading,
    topics,
    submitted,
    score,
    classLevel,
    topic,
    difficulty,
    showPractice,
    setShowPractice,
    audioRef,
    setClassLevel,
    setTopic,
    setDifficulty,
    setData,
    setAnswers,
    setLoading,
    selectAnswer,
    submitAnswers,
    setSubmitted,
    getReadingPassage,
    submitReadingPassage,
  };
};

export default useHandler;
